import { Link } from "react-router-dom";
import FaqAccordion from "@/components/feature/FaqAccordion";
import { siteFaqs } from "@/mocks/site";

export default function FaqSection() {
  return (
    <section className="w-full bg-background-50 py-12 md:py-16">
      <div className="mx-auto grid max-w-[1280px] grid-cols-1 gap-8 px-4 md:px-6 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <span className="flex items-center gap-2 text-xs font-medium tracking-wide text-primary-600">
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-question-line text-base" />
            </span>
            常见问题
          </span>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            第一次来，你可能会问
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            关于内容来源、讨论规则和参与方式，我们把最常被问到的几个问题整理在了这里。如果还有疑问，欢迎随时连线我们。
          </p>
          <Link
            to="/about#connect"
            className="mt-6 inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md bg-accent-500 px-4 py-2.5 text-sm font-medium text-accent-950 transition-colors hover:bg-accent-400"
          >
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-send-plane-fill text-sm" />
            </span>
            还有问题，连线我们
          </Link>
        </div>
        <div className="lg:col-span-8">
          <FaqAccordion items={siteFaqs} />
        </div>
      </div>
    </section>
  );
}